import React from "react";
import { Tabs, Button, Result,Skeleton, Tooltip } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import type { TabsProps } from 'antd';
import {OpenLinksContext} from '../../context'
import type { UrlItem } from '../../context';
type Props = {};

const Iframe = ({url=''}) => {

  const onload  = ()=>{
    console.log("Iframe onload")
    setLoading(false)
  }
  //url="https://login.xiaoshouyi.com/auc/sso/login?ssoKey=255ffa617a&deviceType=web&ssoType=saml"
  //url="https://www.xiaoshouyi.com/"
  const [loading,setLoading]= React.useState(true)
  return(
    <>{/*
        loading?
        (<div className="h-screen p-10">
        <Skeleton loading={loading} active></Skeleton>
        </div>):''
      */}
      {<iframe className="h-[calc(100vh-56px)] w-full border-0" src={url} onLoad={onload}  title={url}/>}

    </>
  )

}

const Frame = (props: Props) => {

  //const [activeKey, setActiveKey] = React.useState(0);
  const onChange = (key: string) => {
    console.log("change:"+key);
    //setActiveKey(key);
    //items[key].label =  <div><ReloadOutlined onClick={()=>console.log('111')}/><span>{context.urls[key]}</span></div>
  };
  const onReload = (index: number)=>{
    console.log("reload"+index)
  };
  const onEdit = (
    targetKey: React.MouseEvent | React.KeyboardEvent | string,
    action: 'add' | 'remove',)=>{
      if (action === 'add') {
         console.log("add")
      } else {
          console.log("remove",targetKey)
      }
  };
  return (
    <div>
      <OpenLinksContext.Consumer>
        {
          context => {
            
            let items: TabsProps['items']=[]
            if(context.routes && context.routes.urls && context.routes.urls.length>0){       
              items  = context.routes.urls.map((url:UrlItem,index:number)=>{
                console.log("url",url)
                const reloadIcon = <ReloadOutlined style={{fontSize:'12px'}}/>
                const reloadBtn = (context.routes.active===index?<Button type="link" icon={reloadIcon} size="small" onClick={()=>{onReload(index);context.reload(index)}} />:'')
                const title = url.title.length>8?<Tooltip title={url.title}>{url.title.slice(0,6)+'..'}</Tooltip>:url.title
                const labelNode = <div  className="tab-label-container">{reloadBtn}{title}</div>
                return {
                  key:index.toString(),
                  label:labelNode,
                  children:<Iframe key={url.ts.toString()}  url={url.url} />,//<iframe className="h-screen w-full" key={url.ts} src="https://e1tableau.english1.com/#/home"   />,
                  closable:true
                }
              });  
              //console.log("items",items)
              return(
                  <div className="h-[100vh] p-[5px]">
                    <Tabs activeKey={context.routes.active.toString()} items={items} 
                      tabBarStyle={{marginBottom: "5px"}}
                      onChange={(k)=>{onChange(k);context.active(parseInt(k));}} 
                      onEdit={(t,a)=>{onEdit(t,a);(a==='remove'?context.remove(parseInt(t as string)):context.add('','',''))}} 
                      hideAdd size="small" type="editable-card" 
                      className="overwrite-antd-tabs"></Tabs>
                  </div> 
              )
            }
            return (
              <div className="h-[100vh] flex justify-center items-center">
                <Result status="404" title="WELCOME"   subTitle="请从菜单选择页面"/>
              </div>
            )
          }
        }
      </OpenLinksContext.Consumer>      {/*<iframe
        className="h-screen w-full"
        src="https://e1tableau.english1.com/#/home"
      />*/}
    </div>
  );
};

export default Frame;
